module.exports = __webpack_public_path__ + "img/wenti1.8eacd920.png";